
import { UseFormRegister, FieldErrors, UseFormWatch } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface InsuranceSectionProps {
  register: UseFormRegister<any>;
  errors: FieldErrors;
  setValue: (name: string, value: any) => void;
  watch: UseFormWatch<any>;
}

export function InsuranceSection({ register, errors, setValue, watch }: InsuranceSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Versicherung & Sozialversicherung</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label>AHV-Nummer</Label>
          <Input 
            {...register("ahv_number", {
              pattern: {
                value: /^756\.\d{4}\.\d{4}\.\d{2}$/,
                message: "AHV-Nummer muss Format 756.XXXX.XXXX.XX haben"
              }
            })} 
            placeholder="756.1234.5678.90"
          />
          {errors.ahv_number && <p className="text-red-500 text-sm">{errors.ahv_number.message as string}</p>}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Krankenkasse</Label>
            <Input 
              {...register("health_insurance_provider")} 
              placeholder="CSS, Helsana, etc."
            />
          </div>
          
          <div className="space-y-2">
            <Label>Unfallversicherung Nummer</Label>
            <Input 
              {...register("accident_insurance_number")} 
              placeholder="UV-Nummer"
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label>Pensionskasse Nummer</Label>
          <Input 
            {...register("pension_fund_number")} 
            placeholder="PK-Nummer"
          />
        </div>
      </CardContent>
    </Card>
  );
}
